// timeUtils.ts
// ———————————————————————————————————————————————————————————————
// Utilidades para conversión de formatos de tiempo SCORM
// ———————————————————————————————————————————————————————————————

/**
 * Convierte segundos a formato SCORM 1.2: HHHH:MM:SS.SS
 * SuccessFactors requiere este formato específico
 */
export function secondsToHMS(totalSec: number): string {
  const s = Math.max(0, totalSec);
  const hours = Math.floor(s / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  const hh = String(hours).padStart(4, "0");
  const mm = String(minutes).padStart(2, "0");
  const ss = seconds.toFixed(2).padStart(5, "0");
  return `${hh}:${mm}:${ss}`;
}

/**
 * Convierte segundos a formato ISO 8601 Duration (SCORM 2004)
 * Ejemplo: PT1H30M45S
 */
export function secondsToISODur(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = Math.floor(s % 60);
  return `PT${h > 0 ? `${h}H` : ""}${m > 0 ? `${m}M` : ""}${sec > 0 || (h === 0 && m === 0) ? `${sec}S` : ""}`;
}

/**
 * Convierte formato SCORM 1.2 (HHHH:MM:SS.SS) a segundos
 */
export function hmsToSeconds(hms: string): number {
  const [h = "0", m = "0", rest = "0"] = hms.split(":");
  const s = parseFloat(rest);
  return +h * 3600 + +m * 60 + Math.floor(s);
}

/**
 * Convierte formato ISO 8601 Duration a segundos
 * Ejemplo: PT1H30M45S -> 5445
 */
export function isoDurToSeconds(dur: string): number {
  const match = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)(?:\.\d+)?S)?$/i.exec(dur);
  if (!match) return 0;
  const h = parseInt(match[1] || "0", 10);
  const min = parseInt(match[2] || "0", 10);
  const s = parseInt(match[3] || "0", 10);
  return h * 3600 + min * 60 + s;
}
